import axios from 'axios';
import qs from 'qs';
import { env } from '@/lib/env';
import { apiClient } from './client';
import type { TokenResponse, UserInfo } from './types';

// Login uses Resource Owner Password Credentials (ROPC) — mirrors Tenant.Web's
// existing flow. The /connect/token endpoint expects form-encoded body.
//
// We bypass apiClient for the login call because there's no token yet and
// we want to control headers explicitly.

export interface LoginRequest {
  username: string;
  password: string;
}

export async function loginWithPassword({ username, password }: LoginRequest): Promise<TokenResponse> {
  const body = qs.stringify({
    grant_type: 'password',
    client_id: env.oauthClientId,
    client_secret: env.oauthClientSecret,
    username,
    password,
    scope: 'openid profile IdentityServerApi offline_access',
  });

  const res = await axios.post<TokenResponse>(`${env.apiUrl}/connect/token`, body, {
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
  });

  return res.data;
}

export async function fetchUserInfo(): Promise<UserInfo> {
  // Uses apiClient (so the bearer header is attached automatically).
  const res = await apiClient.get<UserInfo>('/connect/userinfo');
  return res.data;
}
